export default {
  common: {
    logout: 'Logout',
    help: 'Help',
    docs: 'Documentation',
    retry: 'Retry',
    home: 'Home',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    noResults: 'No results found',
    noData: 'No data available',
    back: 'Back',
    close: 'Close',
    clear: 'Clear',
    rename: 'Rename',
    continue: 'Continue',
    later: 'Do it later',
    previous: 'Previous',
    next: 'Next',
    complete: 'Complete',
    change: 'Change',
    or: 'or',
    loading: 'Loading...',
    loadingData: 'Loading data...',
    create: 'Create',
    update: 'Update',
    remove: 'Remove',
    apply: 'Apply',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    pending: 'Pending',
    viewAll: 'View all',
    errorLoading: 'Error loading data',
    errorLoadingData: 'Error loading data',
    saveChanges: 'Save changes',
    changesSaved: 'Changes saved successfully!',
    saveError: 'Failed to save changes',
    by: 'by',
    download: 'Download',
    insert: 'Insert',
    yes: 'Yes',
    no: 'No',
    language: 'Language',
    theme: {
      title: 'Theme',
      light: 'Light',
      lightTooltip: 'Use light mode',
      dark: 'Dark',
      darkTooltip: 'Use dark mode',
      system: 'System',
      systemTooltip: 'Follow system preference',
    },
    faq: {
      title: 'FAQ',
      description: 'Find answers to frequently asked questions',
    },
    form: {
      unsavedChanges: 'You have unsaved changes',
      save: 'Save',
      cancel: 'Cancel',
      saving: 'Saving...',
      savedSuccessfully: 'Changes saved successfully!',
      saveError: 'An error occurred while saving',
      dismiss: 'Dismiss',
    },
  },
  dates: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    daysAgo: '{days} days ago',
    inDays: 'In {days} days',
    weeksAgo: '{weeks} weeks ago',
    inWeeks: 'In {weeks} weeks',
  },
  errors: {
    system: {
      title: 'Something went wrong',
      message: 'An unexpected error occurred. Please try again.',
      code: 'Error code',
    },
    networkError: 'Network error. Please check your connection.',
    serverError: 'Server error. Please try again later.',
    unknownError: 'An unknown error occurred',
    forbidden: "You don't have permission to do this.",
    rateLimited: 'Too many requests. Wait a moment, then try again.',
    conflict: 'This item changed in the meantime. Reload the page, then try again.',
    validation: 'One of the values entered was refused. Check the form, then try again.',
    notFound: 'This item no longer exists, or is no longer accessible.',
    tooLarge: 'What was sent is too large.',
    unavailable: 'The service is temporarily unavailable. Try again in a moment.',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist or has been moved.',
    backHome: 'Back to home',
  },
  undo: {
    action: 'Undo',
  },
  share: {
    action: 'Share…',
  },
  navigation: {
    main: 'Main navigation',
    apps: 'Apps',
    more: 'More',
    moreActions: 'More actions',
    moreWithTransfers: 'More, {count} transfer to follow | More, {count} transfers to follow',
    profile: 'Profile',
    credits: 'Credits',
    creditsTooltip: 'Balance: {amount}',
    reloadCredits: 'Reload credits',
    sectionPicker: '{title}, {section}: change section',
    sectionPickerPending: '{title}, {section}: change section, {count} waiting | {title}, {section}: change section, {count} waiting',
  },
  table: {
    sortBy: 'Sort by',
    sortChip: 'Sort: {column}',
    sortNone: 'Sort',
    order: 'Order',
    ascending: 'Ascending',
    descending: 'Descending',
    select: 'Select',
    clearSelection: 'Clear the selection',
    selected: '{count} selected',
    selectAll: 'Select all',
  },
  userDrawer: {
    settings: {
      title: 'Settings',
      inviteUsers: 'Invite users',
      account: 'Account Settings',
    },
    quickActions: 'Quick Actions',
    organizations: 'Organizations',
    foundingLimitReached: 'The most this platform allows ({limit})',
    foundingUnverified: 'Confirm your email address first',
    helpLink: 'Help - Documentation',
  },
  pickers: {
    uploadNotServed: 'This upload is not available yet',
    file: {
      clickOrDrag: 'Click or drag files here',
      defaultHelper: 'Max {size}MB per file',
      maxFilesReached: 'Maximum number of files reached',
      uploadError: 'Upload failed',
      fileTooLarge: 'File exceeds {size}MB limit',
      invalidFileType: 'File type not allowed',
    },
    metadataFile: {
      clickOrDrag: 'Click or drag a file here',
      defaultHelper: 'Max {size}MB',
      attachedFile: 'Attached file',
      view: 'View file',
      uploading: 'Uploading...',
      replace: 'Replace',
      remove: 'Remove',
      fileTooLarge: 'File exceeds {size}MB limit',
      invalidFileType: 'File type not allowed',
      uploadFailed: 'Upload failed',
    },
    image: {
      uploading: 'Uploading...',
      replace: 'Replace',
      remove: 'Remove',
      uploadButton: 'Upload Image',
      formats: 'Formats: JPG/PNG/WebP - Max {size}MB',
      fileTooLarge: 'Image exceeds {size}MB limit',
      invalidFileType: 'Only JPG, PNG and WebP images allowed',
      uploadFailed: 'Upload failed',
    },
    color: {
      noColor: 'No color',
    },
    date: {
      selectDate: 'Select a date',
    },
    dateRange: {
      selectRange: 'Select a date range',
      cancel: 'Cancel',
      apply: 'Apply',
      shortcuts: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7Days: 'Last 7 days',
        last30Days: 'Last 30 days',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        thisYear: 'This year',
        lastYear: 'Last year',
      },
    },
  },
  upload: {
    drawer: {
      title: 'Uploads',
      clearCompleted: 'Clear completed',
      empty: 'No uploads',
      emptyHelper: 'Drag files here or click to browse',
    },
    miniDock: {
      uploading: '{count} uploading | {count} uploading',
      pending: '{count} pending | {count} pending',
    },
    dropZone: {
      clickOrDrag: 'Click or drag files here',
      helper: 'Max {size}MB per file',
      maxFilesReached: 'Maximum files reached',
    },
    item: {
      pending: 'Pending',
      uploading: 'Uploading...',
      paused: 'Paused',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
    },
    actions: {
      pause: 'Pause',
      resume: 'Resume',
      cancel: 'Cancel',
      retry: 'Retry',
      remove: 'Remove',
    },
    errors: {
      fileTooLarge: 'File exceeds {size}MB limit',
      tooManyFiles: 'Maximum {max} files allowed',
      uploadFailed: 'Upload failed',
      networkError: 'Network error, will retry',
    },
  },
  editor: {
    insertLink: 'Insert link',
    editLink: 'Edit link',
    linkUrl: 'Link URL',
    insertImage: 'Insert image',
    imageUrl: 'Image URL',
    browseLibrary: 'Browse library',
    dragOrClick: 'Drag & drop or click to upload',
    uploading: 'Uploading…',
    uploadFailed: 'Upload failed',
    insertTable: 'Insert table',
    addRow: 'Add row',
    addColumn: 'Add column',
    deleteTable: 'Delete table',
  },
  imageViewer: {
    close: 'Close',
    download: 'Download',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotateLeft: 'Rotate left',
    rotateRight: 'Rotate right',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit fullscreen',
    previous: 'Previous image',
    next: 'Next image',
    loading: 'Loading image...',
    error: 'Failed to load image',
    retry: 'Retry',
  },
  metadata: {
    linkLabel: 'Display text',
    openFile: 'Open the file',
    noFile: 'No file',
    requiredFieldsWarning: 'Some required fields are not filled in.',
    changed: 'Changed',
    before: 'Before:',
    emptyValue: '(empty)',
    revert: 'Revert',
    requiredFieldsBanner: '{count} required field(s) must be completed before saving.',
  },
  modals: {
    confirm: {
      title: 'Confirm action',
    },
    delete: {
      title: 'Delete',
      confirm: 'Delete',
      warning: 'This action cannot be undone.',
    },
  },
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidUrl: 'Invalid URL',
  },
}
